export const RECOMMENDED_CLICK = 'Recommended click';
export const POPULAR_CLICK = 'Popular click';
export const RECENTLY_VISITED_CLICK = 'Recently visited click';
export const NEW_PRODUCT_CLICK = 'New product click';
export const COMING_SOON_CLICK = 'Coming soon click';
